import { render, staticRenderFns } from "./BarTabList.vue?vue&type=template&id=703d42d5&scoped=true&"
import script from "./BarTabList.vue?vue&type=script&lang=js&"
export * from "./BarTabList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703d42d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('703d42d5')) {
      api.createRecord('703d42d5', component.options)
    } else {
      api.reload('703d42d5', component.options)
    }
    module.hot.accept("./BarTabList.vue?vue&type=template&id=703d42d5&scoped=true&", function () {
      api.rerender('703d42d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-bar/BarTabList.vue"
export default component.exports